import React, { useEffect, useMemo } from 'react';
import { useMediaQuery } from '@mui/material';
import NavbarContext from './NavbarContext';

interface NavbarProviderProps {
  children: React.ReactNode;
}

function NavbarProvider({ children }: NavbarProviderProps): React.ReactElement {
  const [navbarOpen, setNavbarOpen] = React.useState(true);

  const isTablet = useMediaQuery('(max-width:868px)');

  useEffect(() => {
    if (isTablet) {
      setNavbarOpen(false);
    }
  }, [isTablet]);

  const value = useMemo(
    () => ({ navbarOpen, setNavbarOpen }),
    [navbarOpen, setNavbarOpen]
  );

  return (
    <NavbarContext.Provider value={value}>{children}</NavbarContext.Provider>
  );
}

export default NavbarProvider;
